import { ApiResponse } from "@roc/feature-app-core";
import { flow, makeObservable } from "mobx";
import { ConversationAttribute, ConversationData, ResetUnreadCountRequest } from '../types/communicationTypes';
import { CommunicationStore } from "./communicationStore";


export class AppraisalCommunicationStore extends CommunicationStore {

  constructor(globalStore, userStore, communicationService, isInternal = false) {
    super(globalStore, userStore, communicationService, isInternal);
    makeObservable(this, {
      resetUnreadCount: flow,
      updateConversationStarredStatus: flow,
      getParticipantsAllowedByChatRoomId: flow,
    });
  }

  *resetUnreadCount(appraisalId: number) {
    try {
      const request: ResetUnreadCountRequest = {
        chatRoomId: this.currentChatRoomId,
        chatRoomType: this.currentChatRoomType,
        userId: this.userId,
        conversationSid: this.currentConversationSid,
        appraisalId,
      }
      this.communicationService.resetUnreadCount(request);
    } catch (e) {
      // do nothing
    }
  }

  *updateConversationStarredStatus(isStarred: boolean, chatRoomId: number, conversationSid: string, callBack?: () => void) {
    throw Error('Not Implemented!');
  }

  *getParticipantsAllowedByLoanId(id, disableGlobalLoading = false) {
    throw new Error("getParticipantsAllowedByLoanId not implemented for Appraisals");
  }

  *getParticipantsAllowedByChatRoomId(id, disableGlobalLoading = false) {
    try {
      const response: ApiResponse = yield this.communicationService.getParticipantsAllowedByChatroomId(id, disableGlobalLoading);
      const { data } = response;
      return data?.data ?? [];
    } catch (error) {
      console.error("Error retrieving Participants", error);
      return [];
    }
  }

  *setConversationMessageDefaultTag(conversationAttribute: ConversationAttribute, conversationInfo) {
    throw new Error("setConversationMessageDefaultTag not implemented for Appraisals");
  }

  async loadMyConversations(
    start: number,
    pageSize: number,
    onSuccess: (totalCount: number, rows: ConversationData[]) => void,
    onError: () => void = () => { },
    silentRefreshMyConversations = false,
  ) {
    try {
      const response: ApiResponse = await this.communicationService.getAppraisalConversations(Number(this.filters[0]?.value),this.userId);

      const conversationsData: ConversationData[] = response?.data?.data ?? [];
      this.setCurrentConversationId(conversationsData[0]?.conversationSid);
      const totalCount: number = conversationsData.length;
      this._processConversations(conversationsData, totalCount, () => {
        if (conversationsData?.length === 0) {
          this.showNoConversationsMessage = true;
        }
        onSuccess(totalCount, conversationsData);
      }, silentRefreshMyConversations);
    } catch (e) {
      if (!silentRefreshMyConversations) {
        this.globalStore.notificationStore.showErrorNotification({
          message: 'Error fetching appraisal conversation',
        });
      }
      onError();
    }
  }
}
